module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Light-Alphabetic.31687f82.woff2";